export default {
    "layout_chi_siamo": "Chi siamo",
    "layout_orari": "Orari",
    "layout_info": "Info",
    "layout_news": "Novità",
    "layout_indirizzi_consegna": "Indirizzi di consegna",
    "layout_notifiche": "Notifiche",
    "layout_impostazioni": "Impostazioni",
    "layout_login": "Login",
    "layout_logout": "Logout",
    "layout_privacy": "Informativa sulla privacy",
    "layout_fidelity_card": "Fidelity card",
    "layout_prenota_tooltip": "Prenota un tavolo",
    "layout_carrello_tooltip": "Carrello",
    "layout_profilo_tooltip": "Profilo",
    "layout_domanda_titolo": "Quando vuoi mangiare?",
    "layout_opzioni_label": "Opzioni ordine",
    "layout_opzioni_label_csconto_tooltip": "Codici sconto",
    "impostazioni_lingue": "Lingue",
    "impostazioni_notifiche": "Notifiche push",
    "impostazioni_ordini": "Ordini e prenotazioni",
    "impostazioni_ordini_txt": "Notifiche sullo stato degli ordini e delle prenotazioni",
    "impostazioni_sconto": "News e codici sconto",
    "impostazioni_sconto_txt": "Notifiche sulle novit\u00e0 e sui codici sconto",
    "impostazioni_suggerimenti": "Attività e suggerimenti",
    "impostazioni_suggerimenti_txt": "Notifiche personalizzate in base alle tue attività",
    "impostazioni_sempre": "sempre",
    "impostazioni_attive": "attive",
    "impostazioni_login_required": "Accedi per gestire le notifiche.",
    "impostazioni_si": "Si",
    "impostazioni_no": "No",
    "notifiche_valido_tutti_locali": "Valido in tutti i locali",
    "notifiche_valido_locali": "Valido nei locali:",
    "index_ordine_titolo": "dove vuoi ordinare?",
    "ristorante_benvenuto": "benvenuto su",
    "ristorante_consulta": "Consulta il nostro men\u00f9 ed effettua il tuo ordine",
    "ristorante_prenota": "Prenota il tuo tavolo nel nostro locale.",
    "ristorante_sondaggio": "Sondaggio",
    "ristorante_ordina_btn": "ordina adesso",
    "ristorante_prenota_btn": "prenota adesso",
    "ristorante_presentiamo_titolo": "ci presentiamo",
    "ristorante_continua_lettura_btn": "continua a leggere",
    "ristorante_novita_titolo": "ultime novit\u00e0",
    "ristorante_novita-vedi_btn": "vedi tutte le news",
    "ristorante_orario_titolo": "quando ci trovi",
    "ristorante_chiusure_title": "Prossime chiusure",
    "ristorante_contatti_titolo": "per contattarci",
    "ristorante_dettaglio_titolo": "ci presentiamo...",
    "confermato": "Confermato",
    "rifiutato": "Rifiutato",
    "attesa": "Attesa",
    "annullato": "Annullato",
    "ordine_appena_possibile": "Appena possibile",
    "ordine_n_persone": "Scegli il numero di persone",
    "ordine_titolo": "ordina online",
    "ordine_scelta_titolo": "scegli la tipologia",
    "ordine_scelta_data_titolo": "scegli la data",
    "ordine_scelta_orario_titolo": "scegli l'orario",
    "ordine_menu_btn": "Menu",
    "ordine_salva_ordine_btn": "aggiungi all'ordine",
    "ordine_dettaglio": "dettaglio dell'ordine",
    "ordine_numero": "Ordine n°",
    "ordine_annulla_msg": "se desideri annullare l'ordine ti invitiamo a contattare il locale telefonicamente",
    "ordine_torna_storico": "Torna allo storico",
    "ordine_tempo_esaurito_label": "Il tempo a tua disposizione per completare l'ordine è terminato.<br>Seleziona una nuova fascia oraria.",
    "ordine_posti_esauriti_label": "Non ci sono posti per la fascia oraria selezionata",
    "ordine_scegli_orario_label": "scegli l'orario",
    "ordine_opzioni": "opzioni ordine",
    "ordine_inviato": "Ordine inviato<br>con successo",
    "ordine_riepilogo": "riepilogo ordine",
    "ordine_consegna_id": "Consegna in",
    "ordine_fatturare_a": "Fatturare a",
    "ordine_consegna": "Consegna",
    "ordine_sconto": "Codice sconto",
    "ordine_sconto_errato": "Codice errato",
    "ordine_sconto_invalido": "Codice non valido per questo locale",
    "ordine_sconto_applicato": "Sconto applicato",
    "ordine_storico": "Storico ordini",
    "ordini_effettuati": "ordini effettuati",
    "ordini_pagamento": "Pagamento",
    "ordini_riepilogo_label": "Conferma dell'ordine",
    "ordini_data": "effettuato il",
    "ordini_ritiro_label": "Ritiro presso il nostro locale previsto per il giorno",
    "ordini_ore": "alle ore",
    "ordini_ordine": "Ordine",
    "ordini_consegna_giorno": "Consegna prevista per il giorno",
    "ordini_consegna_fascia": "nella fascia oraria",
    "ordini_consegna_indirizzo": "Al seguente indirizzo",
    "ordini_fatturare_nome": "Fatturare a",
    "ordini_note": "Note dell'ordine",
    "ordini_totale": "Totale ordine",
    "ordine_riepilogativa": "Questa email &egrave; riepilogativa dell'ordine appena effettuato",
    "ordine_dettagli": "Per tutti i dettagli dell'ordine vai  nella sezione &quot;Storico ordini&quot; dell'app",
    "ordine_dettagli_ridotto": "Per tutti i dettagli dell'ordine vai  nella sezione &quot;Storico ordini&quot;",
    "ordine_clicca_dettagli": "o clicca su &quot;Dettagli ordine&quot; qui sotto",
    "ordine_dettagli_label": "Dettagli ordine",
    "ordine.prezzo_minimo_no": "Per proseguire devi effettuare una spesa minima di ",
    "ordine.ingredienti": "Ingredienti",
    "ordine.allergeni": "Allergeni",
    "ordine.aggiunte": "Aggiunte",
    "ordine.nessuna_aggiunta_disponibile": "Nessuna aggiunta disponibile",
    "ordine.bloccati_msg": "temporaneamente bloccati",
    "ordine.seleziona_aggiunte": "Seleziona le aggiunte che preferisci",
    "ordine.dettagli_allergeni": "Dettagli sugli allergeni",
    "ordine.allergeni_contenuti_label": "Di seguito gli allergeni contenuti nel prodotto selezionato",
    "ordine.allergeni_informazioni_text": "Queste informazioni si riferiscono ai 14 principali allergeni identificati dalla\n        normativa in vigore (ad eccezione di ingredienti esclusi dalla normativa). Sono stati compilati sulla base dei\n        dati forniti dai nostri fornitori in merito alla composizione dei loro prodotti per gli ingredienti\n        volontariamente incorporati. Tuttavia, non si pu\u00f2 del tutto escludere la presenza accidentale di altri\n        ingredienti allergenici che potrebbero essere intervenuti nella produzione di questi prodotti alimentari dai\n        nostri fornitori o in seguito al loro uso in ristorante.\n        La composizione dei prodotti pu\u00f2 essere soggetta a modifiche. Faremo del nostro meglio per aggiornare questa\n        sezione, specialmente quando veniamo informati del cambiamento della composizione di uno di questi. Vi invitiamo\n        a visitare questa sezione regolarmente e di presentare i vari elementi di questa sezione al vostro medico o\n        allergologo in modo che possa consigliarvi nella scelta del cibo.",
    "ordine.grazie_ok": "grazie, ho capito",
    "ordine.leggenda_informazioni": "Leggenda informazioni",
    "ordine.misura": "Misura",
    "ordine.misura_sel": "Seleziona la misura che preferisci",
    "ordine.variante_titolo": "Variante",
    "ordine.variante_sel": "Seleziona la variante che preferisci",
    "ordine.scegli": "Devi scegliere prodotti per un importo minimo di",
    "carrello_importo_indicativo": "L'importo è indicativo, l'importo effettivo verrà applicato una volta inserito o confermato l'indirizzo di consegna.",
    "carrello_tempo_disponibile": "Da quando cliccherai su \"Prosegui\" avrai 15 minuti per completare l'ordine ed assicurarti le opzioni di data e ora selezionate.",
    "carrello_avviso_spese_consegna": "Le spese di consegna verranno calcolate proseguendo con l'ordine.",
    "carrello_ordine_label": "ordine",
    "carrello_indirizzo_consegna": "Indirizzo di consegna",
    "carrello_predefinito": "Predefinito",
    "carrello_mod_pagamento": "Modalità di pagamento",
    "prenota_mod_pagamento": "Seleziona modalità di pagamento",
    "carrello_mezzo_pagamento": "Come pagherai al ritiro\/consegna?",
    "carrello_pag_contanti_ritiro": "Al ritiro",
    "carrello_pag_contanti_consegna": "Alla consegna",
    "carrello_pag_buoni_pasto": "Buoni pasto",
    "carrello_pag_carte": "Carta di credito",
    "carta_di_credito_consegna": "Alla consegna con bancomat o carta",
    "carta_di_credito_ritiro": "Al ritiro con bancomat o carta",
    "carrello_pag_bancomat": "Bancomat",
    "carrello_richiedi_fattura": "Richiedi fattura",
    "carrello_riepilogo": "Riepilogo carrello",
    "carrello_sconto": "Usa uno sconto",
    "carrello_premio": "Usa un premio",
    "carrello_ins_sconto": "INSERISCI QUI IL CODICE SCONTO",
    "carrello_appl_sconto": "applica codice",
    "carrello_appl_sconto_dett": "Lo sconto viene applicato solo sui prodotti, escluse le spese di spedizione.",
    "carrello_note_generali": "Note dell'ordine",
    "carrello_ord_del": "cancella ordine",
    "carrello_ord_conf": "conferma ordine",
    "carrello_vai_pagamento": "VAI AL PAGAMENTO",
    "carrello_completa_ordine": "COMPLETA ORDINE",
    "carrello_sel_ind_title": "Seleziona indirizzo",
    "carrello_sel_ind_label": "Seleziona l'indirizzo al quale effettuare la consegna",
    "carrello_ind_predefinito": "Usa come indirizzo predefinito",
    "carrello_no_ind_consegna": "NESSUN INDIRIZZO DI CONSEGNA CONFIGURATO",
    "carrello.messaggio_alert_indirizzo": "NESSUN INDIRIZZO DI CONSEGNA SELEZIONATO",
    "carrello.messaggio_alert_fattura": "NESSUN INDIRIZZO DI FATTURAZIONE SELEZIONATO",
    "carrello.indicazione_fattura": "Inserisci un indirizzo di fatturazione cliccando sulla matita a lato",
    "carrello.prd_aggiunto": "Prodotto aggiunto al carrello.",
    "carrello.ingrediente_esaurito": "Per questo prodotto i seguenti ingredienti:",
    "carrello.ingrediente_esaurito2": "sono temporaneamente esauriti. Puoi comunque ordinarlo e specificare se lo desideri un'aggiunta in alternativa.",
    "carrello.sconto_ordine_min_mag": "Per usare questo codice sconto l'ordine minimo deve essere",
    "carrello.escluse_spese_spedizione": "escluse le spese di spedizione",
    "carrello.codice_sconto_usato": "Il codice sconto è già stato utilizzato per il numero massimo di volte consentito",
    "carrello.quantita": "Quantità",
    "carrello.prd_non_disponibili_msg": "Attenzione: alcuni prodotti potrebbero non essere disponibili nella nuova fascia oraria selezionata, verrano tolti dal carrello",
    "carrello.scadenza_carrello": "Scadenza carrello",
    "carrello.scadenza_minuti": "minuti",
    "carrello.rimangono_min": "Ti rimangono",
    "carrello.disponibilita_non_garantita": "per completare l'ordine,<br>al termine dei quali non possiamo garantirti<br>la disponibilità per la data e l'ora selezionate.",
    "account.dati_utente": "Dati utente",
    "account.gestione_indirizzi": "Gestione indirizzi",
    "account.gestione_indirizzi_fatt": "Indirizzo fatturazione",
    "account.storico_ordini": "Storico ordini",
    "account.prenotazioni": "Prenotazioni",
    "account.dati_registrazione": "dati di registrazione",
    "account.termini_condizioni": "Termini e condizioni",
    "account.nuovo_indirizzo_consegna": "Nuovo indirizzo di consegna",
    "account.campanello": "Campanello",
    "account.indirizzo_fatturazione": "Indirizzo di fatturazione",
    "account.mod_indirizzo_fatturazione": "Modifica indirizzo di fatturazione",
    "account.accedi_dati": "accedi con i tuoi dati",
    "account.nome_utente": "Nome utente",
    "account.password.dimenticata": "Hai dimenticato la password",
    "account.accedi": "accedi",
    "account.usr_no_mod": "Per ragioni di sicurezza il nome utente non è modificabile",
    "account.no_registrato": "non sei registrato",
    'account.prosegui_ospite': 'prosegui come ospite',
    "account.registrazione": "Registrazione",
    "account.dati_account": "dati account",
    "account.conf_password": "Ripeti password",
    "account.msg_conf_password_err": "Le due password non coincidono",
    "account.inserire_indirizzo_domanda": "vuoi inserire un indirizzo di consegna",
    "account.via": "Via",
    "account.civico": "N° civico",
    "account.sel_city": "Seleziona la città",
    "account.sel_country": "Seleziona lo stato",
    "account.sel_cap": "Seleziona il cap",
    "account.inserire_ind_fat_domanda": "vuoi inserire un indirizzo di fatturazione",
    "account.reg_soc": "Ragione sociale",
    "account.citta": "Città",
    "account.prv": "Provincia",
    "account.cap": "Cap",
    "account.stato": "Stato",
    "account.acc_termini": "Accettazione termini e condizioni",
    "account.registrarti": "registrarti",
    "account.registrazione_ok": "La registrazione è avvenuta con successo",
    "account.save_ok": "Dati modificati con successo",
    "account.effettua_login": "Effettua il login",
    "account.recupera_password": "recupera password",
    "account.mail_recupera_inviata": "La richiesta è stata inviata con successo",
    "account.ins_utente_rec_password": "Inserisci il tuo account utente per recuperare password",
    "account.recupera_btn": "Recupera",
    "account.recupera_controlla_mail": "Controlla la tua casella di posta elettronica, anche nella cartella spam, ti abbiamo inviato\n        \t\t\t\t\t\t\t\t  le credenziali per accedere al servizio",
    "account.mail.recupera_psw.uno": "Gentile",
    "account.mail.recupera_psw.due": "clicca sul seguente link per impostare una nuova password per il tuo account ",
    "account.mail.recupera_psw.tre": "Lo staff di",
    "account.nuova_password_ind": "Inserisci la nuova password",
    "account.nuova_password_label": "Imposta nuova password",
    "account.account_non_trovato": "Account non trovato",
    "account.campo_obbligatorio": "è un campo obbligatorio",
    "account.psw_coincidenti": "Password e Ripeti password devono coincidere",
    "account.termini_condizioni_msg": "Per poter proseguire si devono accettare i termini e le condizioni",
    "account.acc_privacy_msg": "Per poter proseguire si deve accettare la privacy",
    "account.cntr_spam_msg": "Controlla la tua casella di posta elettronica, anche nella cartella spam, ti abbiamo inviato le credenziali per accedere al servizio",
    "account.cliente_non_trovato": "Cliente non trovato",
    "account.apikey_non_trovata": "Api Key non trovata",
    "account.indirizzo_non_trovato": "Indirizzo non trovato",
    "account.account": "Account",
    "account.delete_title": "Elimina account",
    "account.delete_warning": "Attenzione stai per cancellare il tuo account utente.",
    "account.delete_description": "Procedendo con l'operazione i tuoi dati verranno eliminati e non saranno più recuperabili. Se in futuro vorrai effettuare un nuovo ordine o usufruire dei servizi dell'app, dovrai procedere con una nuova registrazione.",
    "account.delete_confirm": "Elimina account",
    "prenotazione.storico": "storico prenotazioni",
    "prenotazione.effettuate": "prenotazioni effettuate",
    "prenotazione.dettagli": "dettagli prenotazione",
    "prenotazione": "Prenotazione",
    "prenotazione.status": "Status",
    "prenotazione.riferimento": "Riferimento",
    "prenotazione.annulla": "annulla prenotazione",
    "prenotazione.info_annulla": "Per annullare o modificare la prenotazione ti inviatiamo a contattare direttamente il locale tramite numero telefonico",
    "prenotazione_tavolo.richiesta": "richiesta di prenotazione tavolo",
    "prenotazione_tavolo.tavolo_per": "prenota un tavolo per",
    "prenotazione_tavolo.dati": "dati personali",
    "prenotazione_tavolo.privacy": "Accettazione della privacy",
    "prenotazione_tavolo.privacy.informativa": "Leggi l'informativa",
    "prenotazione_tavolo.submit_btn": "Prenota tavolo",
    "prenotazione_tavolo.richiesta_inviata": "La richiesta di prenotazione è stata inviata.",
    "prenotazione_tavolo.richiesta_confermata": "La richiesta di prenotazione è stata confermata.",
    "prenotazione_tavolo.attendi_conferma": "Attendi una conferma da parte del nostro staff!",
    "prenotazione_tavolo.ti_aspettiamo": "Ti aspettiamo!",
    "prenotazione_tavolo.augurio": "Buona continuazione",
    "prenotazione_tavolo.torna_home": "Torna alla home",
    "prenotazione_tavolo.precedente": "precedente",
    "prenotazione_tavolo.successivo": "successivo",
    "prenotazione_tavolo.torna_lista": "Torna alla lista",
    "prenotazioni_tavolo.bloccate": "Prenotazioni momentaneamente bloccate",
    "prenotazioni_tavolo.nessuna": "Nessuna prenotazione effettuata",
    "prenotazioni_tavolo.persona": "persona | persone",
    "prenotazioni_tavolo.persone": "persone",
    "allergeni.glutine": "Glutine",
    "allergeni.crostacei": "Crostacei",
    "allergeni.uova": "Uova",
    "allergeni.pesce": "Pesce",
    "allergeni.arachidi": "Arachidi",
    "allergeni.soia": "Soia",
    "allergeni.latte": "Latte",
    "allergeni.fruttasecca": "Frutta secca",
    "allergeni.sedano": "Sedano",
    "allergeni.senape": "Senape",
    "allergeni.sesamo": "Sesamo",
    "allergeni.molluschi": "Molluschi",
    "allergeni.cereali": "Cereali",
    "allergeni.so2": "Anidride solforosa",
    "news.rimani_aggiornato": "rimani aggiornato",
    "news.lista": "lista news",
    "news.leggi": "Leggi",
    "sconti.lista_title": "lista codici sconto attivi",
    "sconti.ordine_minimo": "Ordine minimo",
    "termini_condizioni.titolo": "Termini e condizioni",
    "termini_condizioni.testo": "KUOKKO ti da il benvenuto!<br>\n        Siamo davvero entusiasti che tu abbia deciso di accedere ed utilizzare i Servizi costituiti dalla nostra piattaforma per gli ordini online, a cui si accede tramite il sito web e le applicazioni KUOKKO per conto dei nostri clienti Ristoranti.<br><br>\n        I presenti Termini e Condizioni d\u2019Uso costituiscono l'accordo tra te (Utente), il Ristorante indicato nei Servizi ed Agaweb srl Unipersonale (Agaweb) societ\u00e0 proprietaria, gestore ed erogatore del Servizio KUOKKO. Disciplinano l'utilizzo dell\u2019applicazione mobile, della web app, dei relativi software e servizi, prenotazioni dei tavoli, commercio a distanza, promozioni e notifiche push (di seguito \u201cServizi\u201d). Prima di utilizzare i Servizi ti invitiamo a leggere i Termini e Condizioni d\u2019Uso ed ad accettarli solo ove compresi e condivisi.<br><br>\n        \n        <b>Utente e responsabilit\u00e0<\/b><br>\n        Per Utente si intende la persona fisica che utilizza i Servizi per scopi personali che ha compiuto la maggiore et\u00e0 e che possiede la capacit\u00e0 di agire (conformemente all\u2019art. 2 del codice civile italiano). L\u2019Utente è responsabile per gli ordini, le prenotazioni e le altre azioni effettuate attraverso i Servizi. Le eventuali offerte sulle bevande alcoliche sono riservate esclusivamente agli Utenti maggiorenni. Ogni utente è responsabile degli alimenti ordinati e consumati, con particolare riferimento ad eventuali intolleranze o allergie. <br><br>\n        \n        <b>Ristorante<\/b><br>\n        Per Ristorante si intende l\u2019esercizio commerciale indicato nei Servizi presso il quale effettuare gli ordini take away o delivery, le prenotazioni dei tavoli e dal quale ricevere notifiche push e promozioni.<br><br>\n        \n        <b>Agaweb srl Unipersonale<\/b><br>\n        Agaweb srl Unipersonale è la societ\u00e0 ideatrice, proprietaria e gestore dei Servizi KUOKKO nonch\u00e9 proprietaria del marchio Kuokko.<br><br>\n        \n        <b>Descrizione del servizio<\/b><br>\n        Kuokko è una piattaforma di ultima generazione per gli ordini online che utilizza le pi\u00f9 recenti tecnologie web e mobile per consentirti di ordinare dal Ristorante e molto altro ancora.<br>\n        Kuokko non vende i prodotti contenuti nel tuo ordine, non è parte di tali transazioni e non ha alcun controllo sulla qualit\u00e0 o sicurezza dei prodotti. Il tuo ordine è tra te (Utente) e il Ristorante dal quale ordini. <br>\n        Il ristorante pu\u00f2 dichiarare gli ingredienti o rappresentare gli allergeni o gli standard di preparazione dei cibi attraverso i Servizi, come ad esempio cibo o bevande che non contengono noci, senza glutine, senza lattosio, biologici o altro. Non esaminiamo n\u00e9 verifichiamo i menu, gli ingredienti, gli standard di preparazione del cibo o eventuali descrizioni o dichiarazioni fatte dai ristoranti.<br> \n        Pertanto, se tu o chiunque consumi un pasto, ingrediente o un qualsiasi altro articolo ordinato tramite i Servizi, ha qualche allergia alimentare o requisiti specifici di preparazione, ti consigliamo vivamente di contattare direttamente il ristorante per soddisfare le tue specifiche esigenze. <br><br>\n        Utilizzando i Servizi, accetti che Kuokko non è responsabile per dichiarazioni o omissioni relative ai prodotti contenuti nel tuo ordine. Forniamo ai visitatori e agli utenti registrati l'accesso ai servizi come descritto nel presente accordo.<br><br>\n        &bull; Visitatori. Nessun accesso è richiesto per i visitatori dei Servizi. I visitatori possono (a) visualizzare tutti i contenuti accessibili al pubblico, (b) inviarci un'e-mail.<br><br>\n        &bull; Utenti registrati. Il login è richiesto per tutti i servizi per utenti registrati. Gli utenti registrati possono fare tutto ci\u00f2 che i visitatori possono fare, e anche (a) effettuare ordini, (b) richiedere una prenotazione, (c) utilizzare codici sconto riservati, (d) ricevere avvisi e altre notifiche.<br><br>\n        Kuokko non ha alcun obbligo di accettare alcun individuo come Utente Registrato e pu\u00f2 accettare o rifiutare qualsiasi registrazione a sua sola e completa discrezione.<br><br>\n        \n        <b>Come effettuare un ordine take away, delivery o una prenotazione<\/b><br>\n        Se non effettui la registrazione, puoi visualizzare il menu senza concludere l\u2019ordine e inviare una richiesta di prenotazione inserendo manualmente i tuoi dati di contatto. Per effettuare un ordine take-away o delivery e gli altri Servizi per utenti registrati, è necessario effettuare la registrazione. Le credenziali dovranno essere mantenute riservate ed ogni utente è responsabile della riservatezza di tali dati. <br>\n        Per effettuare un ordine take away o delivery devi registrarti ed effettuare il log-in. Di seguito potrai scegliere il giorno e l\u2019ora in cui desideri usufruire del servizio e aggiungere i piatti al tuo carrello. Dopo avere completato la scelta del servizio e confermato l\u2019ordine,  quest\u2019ultimo verr\u00e0 processato per il completamento. Riceverai una e-mail o altro tipo di notifica che ti dar\u00e0 conferma del buon fine dell\u2019ordine e riepilogo.<br>\n        Per effettuare una prenotazione puoi effettuare il log-in per evitare di inserire i tuoi dati. Se non effettui il log-in dovrai inserire i tuoi dati manualmente. Di seguito potrai scegliere data, ora e numero di persone che desiderano usufruire del servizio. Riceverai una e-mail o altro tipo di notifica che ti dar\u00e0 conferma o meno del buon fine della prenotazione.<br><br>\n        \n        <b>Mancata esecuzione dell'ordine<\/b><br>\n        In tutti i casi in cui l\u2019ordine non venga processato nessuna responsabilit\u00e0 potr\u00e0 essere attribuita al Ristorante o ad Agaweb. In ogni caso l\u2019eventuale responsabilit\u00e0 del Ristorante è da intendersi limitata entro il valore dell\u2019ordine.<br><br>\n        \n        <b>Cancellazione dell'ordine<\/b><br>\n        Per la cancellazione dell\u2019ordine è necessario contattare il Ristorante e concordare direttamente le modalit\u00e0.<br><br>\n        \n        <b>Pagamenti<\/b><br>\n        L\u2019Utente pu\u00f2 pagare il proprio ordine o Servizio direttamente al ritiro in Ristorante o alla consegna. Pertanto il pagamento è regolamentato direttamente con il Ristorante.<br><br> \n        \n        <b>Sconti e promozioni<\/b><br>\n        Gli eventuali sconti verranno effettuati dal Ristorante che potr\u00e0 crearli in base alle proprie esigenze. Lo sconto avr\u00e0 la durata e l\u2019importo o la percentuale che di volta in volta il Ristorante indicher\u00e0.<br><br>\n        \n        <b>Funzionamento dei Servizi<\/b><br>\n        I Sistemi vengono erogati attraverso gli store Apple e Google. Nessuna responsabilit\u00e0 potr\u00e0 essere attribuita al Ristorante o ad Agaweb in caso di sospensione, modifica o cessazione del servizio da parte di Apple o Google. Apple o Google e il Ristorante o Agaweb sono quattro soggetti giuridici distinti ed indipendenti. Il Ristorante e Agaweb non potranno essere ritenuti responsabili nei confronti dell'Utente per il cattivo funzionamento e\/o l\u2019interruzione dell\u2019operativit\u00e0 dei Servizi, anche per brevi periodi, dovuto ad inconvenienti tecnici hardware, dei software e\/o delle linee di trasmissione e di accesso alla rete o dovuti a caso fortuito, forza maggiore o fatto imputabile a terzi.<br><br>        \n        \n        <b>Efficacia delle condizioni d'uso<\/b><br>\n        Il Ristorante non garantisce che i contenuti dei Servizi siano appropriati o leciti in paesi differenti dall\u2019Italia. L\u2019eventuale invalidit\u00e0, nullit\u00e0 o inefficacia di uno o pi\u00f9 clausole delle presenti Condizioni D\u2019Uso non determiner\u00e0 l\u2019invalidit\u00e0, inefficacia o nullit\u00e0 delle restanti clausole che resteranno valide ed efficaci.<br><br>\n        \n        <b>Modifica delle condizioni d'uso<\/b><br>\n        Il Ristorante tramite Agaweb potr\u00e0 richiedere all\u2019Utente di accettare, di volta in volta, ulteriori condizioni applicabili a parti specifiche o sezioni dell\u2019APP. Tali condizioni ulteriori saranno immesse nelle parti dell\u2019APP a cui si riferiscono e saranno chiaramente identificabili. Il Ristorante tramite Agaweb potr\u00e0 modificare le Condizioni D\u2019Uso le quali saranno applicabili a seguito della pubblicazione online e accettate con l\u2019utilizzo dell\u2019APP.<br><br>\n        \n        <b>Lingua e legge applicabile<\/b><br>\n        La legge che disciplina le Condizioni D\u2019Uso è la legge italiana. Il presente accordo è stato redatto in lingua italiana.<br>\n        Qualsiasi controversia che dovesse derivare dal rapporto regolato dal presente accordo è di competenza esclusiva della giurisdizione ordinaria italiana.<br>",
    "note_generali_label": "Note generali",
    "btn_salva": "Salva",
    "totale": "Totale",
    "dettagli": "Dettagli",
    "btn_annulla": "Annulla",
    "btn_conferma": "Conferma",
    "btn_applica": "Applica",
    "btn_modifica": "Modifica",
    "btn_elimina": "Elimina",
    "btn_indietro": "Indietro",
    "attenzione_label": "Attenzione",
    "nome": "Nome",
    "cognome": "Cognome",
    "email": "Email",
    "telefono": "Telefono",
    "chiudi": "chiudi",
    "sito_manutenzione": "Sito in manutenzione",
    "zona": "Zona",
    "vai_alle": "oppure vai alle",
    "cod_fisc": "Cod. Fisc.",
    "piva": "P.Iva",
    "note": "Note",
    "prosegui": "prosegui",
    "carrello_vuoto": "CARRELLO VUOTO",
    "allergeni_contenuti": "Gli allergeni contenuti o che possono essere presenti:",
    "varianti": "varianti",
    "gusto": "Scelta",
    "gusti": "Scelte",
    "agg_ingr": "aggiungi ingredienti",
    "nessuna": "Nessuna",
    "scarica_app": "Per una migliore esperienza e<br>\n\t\t\t\t\tfluidit\u00e0 ti invitiamo a scaricare la nostra app.<br>\n\t\t\t\t\tDisponibile nell'AppStore e su Google Play.<br>\n\t\t\t\t\tGrazie!",
    "menu": "menu",
    "nessuna_variante": "Nessuna variante",
    "aggiungi": "aggiungi",
    "sconto": "Sconto",
    "nessun_ordine": "Nessun ordine effettuato",
    "messaggio_locale": "Messaggio del locale",
    "chiuso": "Chiuso",
    "sempre_valido": "Sempre valido",
    "prenotazione_nuova": "Nuova",
    "prenotazione_attesa": "In attesa",
    "prenotazione_annullata": "Annullata",
    "prenotazione_rifiutata": "Rifiutata",
    "prenotazione_confermata": "Confermata",
    "carrello.codice_sconto_nonattivo": "Codice sconto non attivo",
    "ore": "ore",
    "aggiunta": "Aggiunta",
    "qta": "qta",
    "select_order_type": "Seleziona la tipologia di ordine tra quelle sopra elencate per scegliere la data e vedere il menu.",
    "eat_at_restaurant": "pre-ordine",
    "al_tavolo": "al tavolo",
    "takeaway": "ritiro",
    "delivery": "consegna",
    "type_message_here": "Scrivi qui il tuo messaggio",
    "mangia_tavolo_label": "Mangia al tavolo previsto per il giorno",
    "contanti": "Contanti",
    "precalculated_fidelity_points_1": "Con questo ordine accumulerai",
    "precalculated_fidelity_points_2": "punti. I punti verranno visualizzati sulla tua fidelity card alla data di ritiro\/consegna.",
    "address_management_changed": "Gestione indirizzi cambiata, è necessario eliminare e ricreare l'indirizzo",
    "fidelity_card_ad_home_c1": "Ad oggi hai accumulato",
    "punti": "punti",
    "dal": "dal",
    "al": "al",
    "fidelity_card_accumulato": "Hai accumulato",
    "fidelity_card_raccogli_1": "Raccogli",
    "fidelity_card_raccogli_2": "punti per ottenere questo premio",
    "fidelity_card_punti_regola_1_1": "I punti si aggiornano nel momento in cui l'ordine viene consumato (data/ora ritiro o consegna).",
    "fidelity_card_punti_regola_1_2": "I premi vengono accumulati automaticamente al raggiungimento della soglia punti necessaria.",
    "fidelity_card_punti_regola_1_3": "Il punteggio totale verrà azzerato al raggiungimento massimo dei punti.",
    "fidelity_card_punti_regola_1_4": "Quando si usa un premio in un ordine, questo verrà cancellato dalla lista dei premi.",
    "fidelity_card_punti_regola_2_1": "I punti si aggiornano nel momento in cui l'ordine viene consumato (data/ora ritiro o consegna).",
    "fidelity_card_punti_regola_2_2": "I premi possono essere scelti una volta raggiunta la soglia punti necessaria.",
    "fidelity_card_punti_regola_2_3": "Il punteggio non verrà azzerato, ma continuerà a crescere in base agli ordini successivi.",
    "fidelity_card_punti_regola_2_4": "Quando si usa un premio in un ordine, il punteggio del premio verrà sottratto dal totale dei punti accumulati.",
    "fidelity_mask_locali_warning": "Attenzione: In questo locale ({NOME_LOCALE}) non puoi accumulare punti e riscuotere premi.",
    "fidelity_card_no_promozione": "Nessuna promozione attiva",
    "fidelity_card_no_premi": "Nessun premio disponibile",
    "valido_dal": "Valido dal",
    "reward": "Premio",
    "fidelity_card_sconto_del_1": "Sconto del",
    "fidelity_card_sconto_del_2": "%",
    "fidelity_card_usato_ordine": "Usato nell'ordine n°",
    "fidelity_card_usato_ordine_del": "del",
    "fidelity_card_premi_utilizzati": "Premi utilizzati",
    "fidelity_card_premi_accumulati": "Premi accumulati",
    "fidelity_card_promozione_non_cumulabile": "Promozione non cumulabile con altre promozioni.",
    "fidelity_card_punti_non_si_azzerano": "I punti non si azzerano alla scadenza della promozione, tuttavia i punti potrebbero essere incompatibili con l’attivazione di una nuova promozione, in tal caso verranno azzerati.",
    "fidelity_card_punti_azzerano_1": "I premi accumulati si azzerano dopo",
    "fidelity_card_punti_azzerano_2": "gg dalla scadenza della promozione.",
    "messaggi": "Messaggi",
    "messaggistica": "Messaggistica",
    "messaggistica_conversazioni_attive": "Conversazioni attive",
    "messaggistica_no_ordine_prenotazione": "Nessun ordine o prenotazione adatta alla messaggistica",
    "messaggeria": "Messaggeria",
    "messaggistica_nessun_messaggio_disponibile": "Nessun messaggio disponibile",
    "valido il": "Valido il",
    "sconto_applicato": "Sconto applicato",
    "premio_applicato": "Premio applicato",
    "indirizzo_non_modificabile": "Indirizzo non più modificabile",
    "indirizzo_non_valido": "Indirizzo non valido, se persiste sarà necessario crearne uno nuovo",
    "sconto_problema_#1": "Non è possibile usare uno sconto quando è attivo un premio",
    "sconto_problema_#2": "Codice sconto non presente",
    "sconto_problema_#3": "Limite di utilizzo raggiunto",
    "sconto_problema_#4": "Lo sconto necessita di un ordine minimo di ",
    "rimuovi_sconto": "rimuovi sconto",
    "seleziona_acconto": "Seleziona l'acconto",
    "usa_premio_ordine": "Usa un premio nel tuo ordine",
    "seleziona_premio": "Seleziona il premio",
    "usa_premio": "Usa premio",
    "premi_accumulati": "Premi accumulati",
    "premio": "Premio",
    "rimuovi_premio": "Rimuovi premio",
    "ore_in_data": "ore",
    "f_privacy_label": "* Ho letto e acconsento all'Informativa sulla Privacy",
    "f_termini_label": "* Ho letto e acconsento ai Termini e Condizioni Generali di Utilizzo",
    "f_servizi_label": "Acconsento all'invio di sconti, promozioni, prodotti consigliati o di materiale pubblicitario tramite l'app o all'indirizzo email fornito",
    "consigliperte": "consigli per te",
    "prodotti_suggeriti": "Prodotti suggeriti",
    "password": "password",
    "confirm_remove_address": "Sei sicuro/a di voler elimiare l'indirizzo?",
    "gratis": "Gratis",
    "limite_tempo_terminato": "Il limite di tempo per effettuare la conversazione è terminato",
    "down_payment": "Acconto",
    "impossible_confirm_payment": "Impossibile confermare il pagamento",
    "label_carta_credito": "Carta di credito o debito",
    "label_titolare_carta": "Titolare della carta",
    "adds_not_availabe_with_config": "Non è possibile aggiungere ingredienti a questo prodotto con le caratteristiche selezionate.",
    "max_scelte": "max {n} scelta | max {n} scelte",
    "aggiunte_gratis": "prima aggiunta gratis | prime {n} aggiunte gratis",
    "max_picks_reached_1": "Il prodotto selezionato consente un massimo di",
    "max_picks_reached_2": "gusti per",
    "max_picks_reached_3": "scelte.",
    "max_picks_reached_4": "Numero massimo di gusti raggiunto.",
    "scegli": "Scegli",
    "no_more_availability": "Prodotto non disponibile",
    "more_than_availability": "Più di {n} disponibili",
    "residual_availability": "Disponibilità residua",
    "out_of_stock_single_begin": "Per questo prodotto l'ingrediente",
    "out_of_stock_single_end": "è temporaneamente esaurito. Puoi comunque ordinarlo e specificare se desideri un'aggiunta in alternativa.",
    "out_of_stock_multiple_begin": "Per questo prodotto gli ingredienti",
    "out_of_stock_multiple_end": "sono temporaneamente esauriti. Puoi comunque ordinarlo e specificare se desideri un'aggiunta in alternativa.",
    "min_free_picks_alert": "E' necessario inserire almeno {n} gusto | E' necessario inserire almeno {n} gusti",
    "cambio_locale_carrello_alert": "Il carrello verrà svuotato. Procedere?",
    "spesa_min_indirizzo": "La spesa minima per l'indirizzo selezionato è",
    "save_into_my_data": "Salva nei miei dati",
    "premio_problema_#1": "Non è possibile usare un premio quando è attivo uno sconto",
    "cannot_select_reward_1": "Non puoi selezionare il premio",
    "cannot_select_reward_2": "in quanto non hai nel carrello un prodotto corrispondente",
    "continua_con_google": "Continua con Google",
    "continua_con_apple": "Continua con Apple",
    "scegli_come_ordinare": "Scegli come ordinare",
    "scegli_zona": "Scegli la zona",
    "scegli_locale": "Scegli il locale",
    "punto_consegna": "Punto di consegna",
    "messaggio_alert_punto_consegna": "E' necessario inserire il punto di consegna",
    "scegli_piatti": "Scegli i piatti",
    "alert_combo_picks_min_prod": "E' necessario inserire almeno un prodotto | E' necessario inserire almeno {n} prodotti",
    "n_prodotti": "1 prodotto | {n} prodotti",
    "di_cui": "Di cui",
    "della_categoria": "della categoria {category}",
    "necessario_un_prodotto": "E' necessario inserire almeno un prodotto",
    "soglia_minima_prodotto": "La soglia minima per il prodotto è",
    "prezzo_fisso": "Prezzo fisso",
    "prezzo_minimo": "Prezzo minimo",
    "nessuna_fascia_trovata": "Nessuna fascia trovata per questo indirizzo",
    "min": "Min",
    "combo": "COMBO",
    "scegli_citta": "Scegli la citta",
    "indirizzo": "Indirizzo",
    "numero": "Numero",
    "seleziona_citta": "Seleziona città",
    "removed_free_pick_alert_1": "Per questo prodotto la scelta | Per questo prodotto le scelte",
    "removed_add_alert_1": "Per questo prodotto l' aggiunta | Per questo prodotto le aggiunte",
    "removed_add_free_pick_alert_2": "è temporaneamente non disponibile e verrà rimossa dal prodotto | sono temporaneamente non disponibili e verranno rimosse dal prodotto",
    "continuare_indirizzo": "Vuoi continuare con questo indirizzo ricercato?",
    "nessun_indirizzo_selezionato": "Nessun indirizzo selezionato",
    "indirizzi_fuori_zona": "Indirizzi fuori zona:",
    "no": "no",
    "yes": "sì",
    "azienda": "Azienda",
    "privato": "Privato",
    "error_cap": "Non siamo riusciti a rilevare il CAP, si prega di riprovare con un altro indirizzo",
    "error_numero": "Non siamo riusciti a rilevare il numero civico, si prega di riprovare con un altro indirizzo",
    "nessuna_fascia_disponibile": "Nessuna fascia disponibile",
    "nessun_metodo_selezionato": "Nessun metodo di pagamento selezionato",
    "salva_carta": "Salva i dati della carta per gli ordini successivi",
    "aggiungi_carta": "Aggiungi una carta di credito",
    "stato_pagamento": "Stato pagamento",
    "pagamento_attesa": "In attesa della conferma di pagamento",
    "pagamento_pagato": "Pagato",
    "pagamento_fallito": "Fallito",
    "metodi_pagamento_title": "Metodi di pagamento",
    "aggiungi_carta_title": "Aggiungi carta",
    "confirm_remove_metodo_pagamento": "Sei sicuro/a di voler elimiare il metodo di pagamento?",
    "gestisci_carte_salvate": "GESTISCI LE CARTE SALVATE",
    "scad": "Scad.",
    "attendi_attimo": "Attendi un attimo",
    "elaborazione_pagamento": "Stiamo elaborando il pagamento",
    "nn_chiudere_browser": "non chiudere la finestra del browser",
    "grazie": "Grazie",
    "spedizione_gratuita": "SPEDIZIONE GRATUITA",
    "coupon_spedizione_gratuita": "SPESE DI CONSEGNA GRATUITE",
    "dil": "DELIVERY IN LOCO",
    "delivery_description": "(a domicilio)",
    "dil_description": "(consegna senza indirizzo)",
    "sp_select": "SELEZIONA UN PUNTO DI SERVIZIO",
    "select": "Seleziona",
    "qr_scan": "SCANSIONA QR CODE",
    "qr_new_scan": "SCANSIONA NUOVO QR CODE",
    "selected_table": "TAVOLO SELEZIONATO",
    "inserisci_indirizzo": "INSERISCI L'INDIRIZZO",
    "msg_nussun_ristorante": "L’indirizzo inserito non è servito da nessun locale. Inserisci un nuovo indirizzo e riprova.",
    "msg_inserisci_indirizzo": "Inserisci l’indirizzo di consegna per vedere i locali che effettuano il servizio nella tua zona.",
    "trovami": "Trovami",
    "label_indirizzo_consegna": "INDIRIZZO DI CONSEGNA",
    "label_indirizzo_salvato": "OPPURE SCEGLI UN INDIRIZZO SALVATO",
    "sconti_non_applicabili": "Sconti non applicabili",
    "variante_obbligatoria_alert": "Attenzione, devi effettuare una scelta per il campo: {etichetta}",
    "min_aggiunte_necessarie_sing": "È necessario inserire almeno {MIN_AGGIUNTE} aggiunta del gruppo {GRUPPO}",
    "min_aggiunte_necessarie_plur": "È necessario inserire almeno {MIN_AGGIUNTE} aggiunte del gruppo {GRUPPO}",
    "racer_ready": "Pronto per la consegna",
    "racer_assigned": "Ordine assegnato al rider",
    "racer_on_delivery": "In consegna",
    "racer_delivered": "Consegnato",
    "racer_undeliverable": "Consegna non effettuabile",
    "racer_cancelled": "Consegna annullata",
    "attivo_solo_per": "Attivo solo per",
    "coupon_non_utilizzabile": "Codice sconto non utilizzabile per questa tipologia di ordine",

    /* NUOVI TESTI 2026 */
    "feedback": "Feedback",
    "feedback_invia": "Invia feedback",
    "feedback_intro_text": "Per noi la tua opinione è importantissima perché ci aiuta a migliorare il servizio.",
    "feedback_intro_completed_text": "Ti ringraziamo per il tempo che ci hai dedicato, i tuoi suggerimenti sono sempre preziosi e contribuiranno a rendere il nostro servizio sempre migliore!",
    "feedback_non_disponibile": "Feedback non disponibile",
    "feedback_no_questions": "Nessuna domanda disponibile",
    "feedback_domande_incomplete": "Compila tutte le domande prima di inviare",
    "feedback_inviato_successo": "Grazie, il tuo feedback è stato inviato!",
    "feedback_inviato_il": "Inviato il",
    "feedback_ordine_numero": "Ordine n°:",
    "riordina": "Riordina",
    "ordina": "Ordina",
    "codici_sconto": "codici sconto",
    "fidelity": "Fidelity",
    "card": "Card",
    "invia_sondaggio": "Invia sondaggio",
    "sondaggio_completato": "Sondaggio completato",
    "sondaggio_rispondi": "Rispondi alle domande",
    "sondaggio_login_title": "Accedi per compilare il sondaggio",
    "sondaggio_login_description": "Effettua il login per rispondere alle domande e ricevere l'eventuale codice sconto.",
    "sondaggio_non_disponibile": "Sondaggio non disponibile",
    "sondaggio_completed_intro": "Il sondaggio è stato completato!",
    "sondaggio_completed_coupon_available": "Ecco il tuo codice sconto:",
    "sondaggio_completed_coupon_hint": "Lo riceverai anche tramite mail (dai un'occhiata anche nella spam) e in più lo troverai nella sezione codici sconto dell'App.",
    "sondaggio_completed_coupon_used": "Hai già utilizzato il codice sconto in un ordine.",
    "sondaggio_completed_thanks": "Grazie, i tuoi suggerimenti ci aiutano a migliorare il servizio.",
    "inserisci_codice": "Inserisci il coodice",
    "inserisci_codice_oppure": "oppure clicca su un codice tra quelli riportati qui sotto",


}
